var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.layout,{tag:"div",attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.fullpath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }